import { render, staticRenderFns } from "./UserStores.vue?vue&type=template&id=000edfe7"
import script from "./UserStores.vue?vue&type=script&lang=js"
export * from "./UserStores.vue?vue&type=script&lang=js"
import style0 from "./UserStores.vue?vue&type=style&index=0&id=000edfe7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports